export default "__VITE_ASSET__CrrCw05p__"